import { FC } from "react";

import { Input, Switch, Typography } from "@mui/material";
import DataTable, { CellSize } from "../table";
import { GridRowsProp, GridColDef, GridRowParams, GridActionsCellItem } from "@mui/x-data-grid-pro";
import RemoveIcon from "@mui/icons-material/Remove";
import { cacheService } from "../../../Core/Api/services";
import { useTranslation } from "react-i18next";

export type BroadcasterLinkedFieldsTableProps = {
    rows: any[];
    onChange: (value: any, id: number, field: string) => void;
    onRemoveRow: (id: number, index: number) => void;
};

const BroadcasterLinkedFieldsTable: FC<BroadcasterLinkedFieldsTableProps> = (props) => {
    const { t } = useTranslation();
    const { onChange, onRemoveRow } = props;
    const rows: GridRowsProp = props.rows;
    type Row = (typeof rows)[number];

    const linkedFieldsColumns: GridColDef[] = [
        {
            field: "fieldId",
            headerName: t("table:headerName.fieldId"),
            minWidth: CellSize.small,
            flex: CellSize.small,
            sortable: false,
        },
        {
            field: "name",
            headerName: t("common:labelUpperCase"),
            minWidth: CellSize.xlarge,
            flex: CellSize.xlarge,
            renderCell: (data: Row) => (
                <Typography>{cacheService.GetMetadata().find((x) => x.id === data?.row?.fieldId)?.label || ""}</Typography>
            ),
        },
        {
            field: "isMandatory",
            headerName: t("table:headerName.isMandatory"),
            minWidth: CellSize.medium,
            flex: CellSize.medium,

            sortable: false,
            renderCell: (data: Row) => (
                <Switch checked={data.value} onChange={(e) => onChange(data.value ? false : true, data.id, data.field)} />
            ),
        },
        {
            field: "maxSynoLongChars",
            headerName: t("table:headerName.maxSynoLongChars"),
            minWidth: CellSize.medium,
            flex: CellSize.medium,
            sortable: false,
            renderCell: (data: Row) => (
                <Input
                    type="number"
                    onChange={(e) => {
                        onChange(e.target.value, data.id, data.field);
                    }}
                    value={data.value}
                />
            ),
        },
        {
            field: "maxSynoShortChars",
            headerName: t("table:headerName.maxSynoShortChars"),
            minWidth: CellSize.medium,
            flex: CellSize.medium,
            sortable: false,
            renderCell: (data: Row) => (
                <Input
                    type="number"
                    onChange={(e) => {
                        onChange(e.target.value, data.id, data.field);
                    }}
                    value={data.value}
                />
            ),
        },

        {
            field: "actions",
            type: "actions",
            align: "right",
            minWidth: CellSize.actionsDefault,
            flex: CellSize.actionsDefault,
            getActions: (params: GridRowParams) => [
                <GridActionsCellItem
                    icon={<RemoveIcon />}
                    label={t("table:cellLabel.removeCastRow")}
                    onClick={() => onRemoveRow(params?.row?.id, params?.row?.index)}
                />,
            ],
        },
    ];

    return (
        <DataTable
            noControls
            rows={rows}
            columns={linkedFieldsColumns}
            getRowHeight={() => "auto"}
            checkboxSelection={false}
            disableRowSelectionOnClick
            sx={{ width: "99.8%" }}
        />
    );
};

export default BroadcasterLinkedFieldsTable;
